/**
 * ActionParam値：パラメータ値のセットに用いる
 */
export type UrlActionParam = (typeof UrlActionParam)[keyof typeof UrlActionParam];
export const UrlActionParam = {
  /** 言語情報="ja"(日本語)の場合, ActionParamは"Menu"をセット */
  jaActionParam: 'Menu',
  /** 上記以外の場合, ActionParamは"MenuEn"をセット */
  otherActionParam: 'MenuEn',
} as const;
